import React from "react";
import { motion } from "framer-motion";

const EASE = [0.2, 0.8, 0.2, 1];

/** Fades and rises once when it scrolls into view. `as` picks the element. */
export default function Reveal({ as = "div", className = "", delay = 0, y = 26, children, ...rest }) {
  const Tag = motion[as] || motion.div;
  return (
    <Tag className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "0px 0px -12% 0px" }} transition={{ duration: 0.65, delay, ease: EASE }} {...rest}>
      {children}
    </Tag>
  );
}

/** A paper object that prints in: revealed from the top edge down, like it is coming out of a printer. */
export function PrintIn({ className = "", delay = 0, duration = 1.2, children, ...rest }) {
  return (
    <motion.div className={className} initial={{ clipPath: "inset(0 0 100% 0)" }} whileInView={{ clipPath: "inset(0 0 -4% 0)" }} viewport={{ once: true, margin: "0px 0px -15% 0px" }} transition={{ duration, delay, ease: "linear" }} {...rest}>
      {children}
    </motion.div>
  );
}
